import './style.sass';
import { CopyButton } from '../CopyBtn';

type Props = {
    url: string,
    className?: string,
    onCopy?: () => void,
};

export const UrlCopyItem = ({ url, className, onCopy }: Props) => {
    const onClickCopy = () => {
        navigator.clipboard.writeText(url);

        if (onCopy) {
            onCopy();
        }
    };

    return (
        <div className={`url-copy-item ${className ? className : ''}`}>
            <span className="p1-medium">{url}</span>

            <CopyButton onClick={onClickCopy} popupPosition='right'/>
        </div>
    );
};
